export const routes = {
  // predictImage: "http://localhost:8080/predict",
  predictImage: "https://canada-goose-authenticator-1-xfswzdtnbq-uw.a.run.app",
};
